/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoAccountInfoBaseResponse as ModelsAccountDtoAccountInfoBaseResponse } from '../../models/Models/Account/dto-account-info-base-response';

export interface V4AccountsEntityIdInfoGet$Plain$Params {
  entityId: string;
}

export function v4AccountsEntityIdInfoGet$Plain(http: HttpClient, rootUrl: string, params: V4AccountsEntityIdInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4AccountsEntityIdInfoGet$Plain.PATH, 'get');
  if (params) {
    rb.path('entityId', params.entityId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>;
    })
  );
}

v4AccountsEntityIdInfoGet$Plain.PATH = '/v4/accounts/{entityId}/info';
